import {Drawer as AntdDrawer} from 'antd';
import type {DrawerProps as AntdDrawerProps} from 'antd';
import {createCx, mergeSemanticClassNames} from '@utils/cx';
import styles from './index.module.less';
import iconClose from './assets/icon-close.png'; // todo: 换成UI的icon

const cx = createCx(styles);

const defaultCloseIcon = <img src={iconClose} alt="关闭" className={cx('closeIcon')} />;

const Drawer: React.FC<AntdDrawerProps> = ({open, rootClassName, classNames, ...restProps}) => {
    const mergedClassNames = mergeSemanticClassNames({}, classNames);

    return (
        <AntdDrawer
            open={open}
            keyboard
            placement="right"
            closeIcon={defaultCloseIcon}
            closable={{placement: 'end'}}
            rootClassName={cx('drawer', rootClassName)}
            classNames={mergedClassNames}
            {...restProps}
        />
    );
};

export default Drawer;
